import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { DomainItemModule } from './domain-item/domain-item.module';
import { DomainManagerComponent } from './domain-manager.component';

@NgModule({
    imports: [SharedModule, DomainItemModule],
    declarations: [DomainManagerComponent],
    entryComponents: [DomainManagerComponent],
    exports: [DomainManagerComponent]
})
export class DomainManagerModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/domain-manager/domain-manager.module.ts